import { useRef, useState, useEffect } from 'react';
import { View, StyleSheet, Image, Animated } from 'react-native';
import { theme, Text } from '@socrait/react';

import splashImageUrl from '~/assets/images/splash_image.png';

const ROTATION_INTERVAL_MS = 4500;

const HEADLINES = [
  { prefix: 'Your ', bold: 'Voice.' },
  { prefix: 'Your ', bold: 'Data.' },
  { prefix: 'Your ', bold: 'Peace of Mind.' },
] as const;

export function usePhaseAnimation() {
  const [phase, setPhase] = useState(0);
  const fadeAnim = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    const id = setInterval(() => {
      Animated.timing(fadeAnim, {
        toValue: 0,
        duration: theme.animation.long,
        useNativeDriver: false,
      }).start(() => {
        setPhase((p) => (p + 1) % 3);
        Animated.timing(fadeAnim, {
          toValue: 1,
          duration: theme.animation.long,
          useNativeDriver: false,
        }).start();
      });
    }, ROTATION_INTERVAL_MS);
    return () => clearInterval(id);
  }, [fadeAnim]);

  return { phase, fadeAnim };
}

interface SplashPanelProps {
  phase: number;
  fadeAnim: Animated.Value;
}

export function SplashPanel({ phase, fadeAnim }: SplashPanelProps) {
  return (
    <View style={styles.container}>
      <Image source={{ uri: splashImageUrl }} style={styles.splashImage} resizeMode="contain" />
      <Animated.View style={[styles.headlineWrapper, { opacity: fadeAnim }]}>
        <Text style={styles.headline}>
          {HEADLINES[phase]!.prefix}
          <Text style={styles.headlineBold}>{HEADLINES[phase]!.bold}</Text>
        </Text>
      </Animated.View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing.xlarge,
  },
  splashImage: {
    width: 280,
    aspectRatio: 560 / 284,
  },
  headlineWrapper: {
    alignItems: 'center',
  },
  headline: {
    fontSize: 32,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeights.bold,
    color: theme.colors.navy,
    textAlign: 'center',
  },
  headlineBold: {
    fontSize: 32,
    fontFamily: theme.fonts.regular,
    fontWeight: theme.fontWeights.bold,
    color: theme.colors.primaryPurple,
  },
});
